import React, { useState, useEffect } from 'react'
import { Checkbox, CardContent, Grid, FormControlLabel } from '@material-ui/core'

import { useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import CalistaAdvisoryKeys from 'src/constants/locale/key/CalistaAdvisory'

function TransactionTypeFilter({
    clearAllFilterClickedTime,
    onChange
}) {

    // Translations ------------------------------------------------------------
    const { translate } = useTranslation(Namespace.CALISTA_ADVISORY)
    const FilterKeys = CalistaAdvisoryKeys.CIA_ADMIN_MANAGEMENT.FILTERS;

    const Labels = {
        TRANSACTION_TYPE: translate(Namespace.CALISTA_ADVISORY, CalistaAdvisoryKeys.FIELDS.TRANSACTION_TYPE),
        ALL: translate(Namespace.CALISTA_ADVISORY, FilterKeys.ALL),
        LANDED_COST: translate(Namespace.CALISTA_ADVISORY, FilterKeys.LANDED_COST),
        E_ADVISORY: translate(Namespace.CALISTA_ADVISORY, FilterKeys.E_ADVISORY),
        HS_CODE_RECOMMENDATION: translate(Namespace.CALISTA_ADVISORY, FilterKeys.HS_CODE_RECOMMENDATION)
    }

    //* ------------------------------------------------------------------------
    const DEFAULT_CHECKED_VALUES = { ALL: true }
    const [checkedValues, setCheckedValues] = useState({ ...DEFAULT_CHECKED_VALUES })

    // The 'ALL' checkbox need special handling.
    const allCheckboxChangeHandler = (event) => {
        let currentChecked = checkedValues.ALL

        // Uncheck everything else, and change the current.
        let newCheckedValues = { ...DEFAULT_CHECKED_VALUES }
        newCheckedValues.ALL = !(currentChecked)
        setCheckedValues(newCheckedValues)
    }

    // The other 3 checkboxes
    const checkboxChangeHandler = (event) => {
        let checkboxValue = event.target.value

        let currentChecked = (checkedValues[checkboxValue] == true)

        let newCheckedValues = { ...checkedValues }
        newCheckedValues[checkboxValue] = !(currentChecked)
        setCheckedValues(newCheckedValues)
    }

    // Monitor the Clear All clicked time. When changed, reset the value.
    useEffect(() => {
        setCheckedValues({ ...DEFAULT_CHECKED_VALUES })
    }, [clearAllFilterClickedTime])

    useEffect(() => {

        // Trigger the onChange when checkedValues are changed.
        if (onChange) {
            let selectedValues = []

            for (let [key, value] of Object.entries(checkedValues)) {
                if (value == true) {
                    selectedValues.push(key)
                }
            }

            onChange(selectedValues)
        }
    }, [checkedValues])

    //* return JSX -------------------------------------------------------------
    return (

        //* Start JSX ----------------------------------------------------------
        <Grid container>
            <Grid item xs={12}>
                <CardContent style={{
                    background: '#8996AF10',
                    padding: '1em',
                    marginTop: '1em',
                    textTransform: 'uppercase',
                    fontWeight: 'bold'
                }}>
                    {Labels.TRANSACTION_TYPE}
                </CardContent>
            </Grid>
            <Grid item xs={12}>
                <CardContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <FormControlLabel label={Labels.ALL}
                                control={
                                    <Checkbox
                                        checked={checkedValues.ALL}
                                        onChange={allCheckboxChangeHandler}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                            <FormControlLabel label={Labels.LANDED_COST}
                                disabled={(checkedValues.ALL == true)}
                                control={
                                    <Checkbox value='LANDED_COST'
                                        checked={(checkedValues.ALL) || (checkedValues.LANDED_COST)}
                                        onChange={checkboxChangeHandler}
                                    />
                                }
                            />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                            <FormControlLabel label={Labels.E_ADVISORY}
                                disabled={(checkedValues.ALL == true)}
                                control={
                                    <Checkbox value='E_ADVISORY'
                                        checked={(checkedValues.ALL) || (checkedValues.E_ADVISORY)}
                                        onChange={checkboxChangeHandler}
                                    />
                                } />
                        </Grid>
                        <Grid item xs={12} xl={6}>
                            <FormControlLabel label={Labels.HS_CODE_RECOMMENDATION}
                                disabled={(checkedValues.ALL == true)}
                                control={
                                    <Checkbox value='HS_CODE_RECOMMENDATION'
                                        checked={(checkedValues.ALL) || (checkedValues.HS_CODE_RECOMMENDATION)}
                                        onChange={checkboxChangeHandler}
                                    />
                                }
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Grid>
        </Grid>
        //* End JSX ------------------------------------------------------------
    );

    //* End of function --------------------------------------------------------
}

export default TransactionTypeFilter
